import { useEffect, useState } from "react";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { importModule } from "./import-module.js";
async function loadComponents(document) {
    try {
        const getComponents = await importModule(document, {
            packageName: "@amzn/awsui-widget-app-layout",
            majorVersion: "3",
        });
        return getComponents({ React, ReactDOM });
    }
    catch (error) {
        console.warn("Failed to load app layout widget", error);
    }
}
// cache separate instances for each iframe rendered a widget
let instancesMap = new WeakMap();
export function useRemoteComponents(ref, fallback) {
    const [components, setComponents] = useState({});
    useEffect(() => {
        var _a, _b;
        let mounted = true;
        const doc = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.ownerDocument) !== null && _b !== void 0 ? _b : document;
        let loadComponentsPromise = instancesMap.get(doc);
        if (!loadComponentsPromise) {
            loadComponentsPromise = loadComponents(doc);
            instancesMap.set(doc, loadComponentsPromise);
        }
        loadComponentsPromise.then((components) => {
            if (!mounted) {
                return;
            }
            setComponents(components !== null && components !== void 0 ? components : fallback);
        });
        return () => {
            mounted = false;
        };
    }, []);
    return components;
}
